import { DefaultSectionCopy, Section } from "@hydrologiq/shared/providers/CopyProvider"

const copy: DefaultSectionCopy = {
  type: Section.CONNECTIONS,
  name: "Connections",
  base: "connections",
  routes: [],
  buttons: [],
  headings: [],
  statuses: [],
}

export default copy
